import { doc, increment, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../firbase/firebase";

export const updateStatsOnCreate = async (type, status) => {
  if (status !== "published") return;
  console.log("type, status ", type, status);

  const date = new Date(); // current time

  console.log("date", date);

  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString();

  await setDoc(
    doc(db, "stats", "totals"),
    { [type]: increment(1) },
    { merge: true },
  );

  // await setDoc(
  //   doc(db, "stats", year),
  //   { [`${type}.${month}`]: increment(1) },
  //   { merge: true },
  // );

  await setDoc(
    doc(db, "stats", year),
    { [type]: { [month]: increment(1) } },
    { merge: true },
  );
};

export const updateStatsOnDelete = async (type, createdAt, status) => {
  try {
    if (status !== "published") return;
    if (!type || !createdAt) return;

    console.log("FROM DELETE FUNCTION type, status ", type, status);
    console.log("from delete createdAt", createdAt);

    let date;

    // ✅ Firestore Timestamp
    if (createdAt?.toDate) {
      date = createdAt.toDate();
    }

    
    // ✅ If already JS Date
    else if (createdAt instanceof Date) {
      date = createdAt;
    } else {
      console.log("Invalid createdAt format");
      return;
    }

    if (isNaN(date.getTime())) return;

    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString();


    console.log("from delete after parsing date --", date);
    console.log("from delete after parsing date --", year, month);

    
    // 🔹 Decrement totals
    await setDoc(
      doc(db, "stats", "totals"),
      { [type]: increment(-1) },
      { merge: true },
    );

    // 🔹 Decrement correct month inside correct year
    // await setDoc(
    //   doc(db, "stats", year),
    //   { [`${type}.${month}`]: increment(-1) },
    //   { merge: true },
    // );

    console.log("year, type, month, --",year, type, month );
    

    await setDoc(
      doc(db, "stats", year),
      { [type]: { [month]: increment(-1) } },
      { merge: true },
    );

  } catch (error) {
    console.error("Error updating stats on delete:", error);
  }
};
